import VerticalOptionsMenu from './menus/VerticalOptionsMenu.js';

export default class SaveFileMenu {
    constructor() {
        const slot0Data = localStorage.getItem('pkmng0');
        const slot1Data = localStorage.getItem('pkmng1');
        const slot2Data = localStorage.getItem('pkmng2');
        const slot3Data = localStorage.getItem('pkmng3');

        let slot0 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot1 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot2 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot3 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        if (slot0Data !== null) {
            const parsedData = JSON.parse(slot0Data);
            slot0 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot1Data !== null) {
            const parsedData = JSON.parse(slot1Data);
            slot1 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot2Data !== null) {
            const parsedData = JSON.parse(slot2Data);
            slot2 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot3Data !== null) {
            const parsedData = JSON.parse(slot3Data);
            slot3 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        this.options = [slot0, slot1, slot2, slot3];
        this.currentOption = 0;
        this.saveFileDetailMenu = new VerticalOptionsMenu({
            options: ['Load', 'Cancel', 'Delete'],
        });
    }

    update() {
        const slot0Data = localStorage.getItem('pkmng0');
        const slot1Data = localStorage.getItem('pkmng1');
        const slot2Data = localStorage.getItem('pkmng2');
        const slot3Data = localStorage.getItem('pkmng3');

        let slot0 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot1 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot2 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };

        let slot3 = {
            playerName: 'New Game',
            lastSave: null,
            pokedex: null,
        };
        if (slot0Data !== null) {
            const parsedData = JSON.parse(slot0Data);
            slot0 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot1Data !== null) {
            const parsedData = JSON.parse(slot1Data);
            slot1 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot2Data !== null) {
            const parsedData = JSON.parse(slot2Data);
            slot2 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        if (slot3Data !== null) {
            const parsedData = JSON.parse(slot3Data);
            slot3 = {
                playerName: parsedData.gameState.overworldStateMachine.player.name,
                lastSave: parsedData.timestamp,
                pokedex: parsedData.gameState.overworldStateMachine.player.pokedex.caught.length,
            };
        }

        this.options = [slot0, slot1, slot2, slot3];
    }

    increaseVerticalOption() {
        if (this.currentOption === 3) {
            this.currentOption = 0;
            return;
        }

        this.currentOption = (this.currentOption + 1) % 4;
    }

    decreaseVerticalOption() {
        if (this.currentOption === 0) {
            this.currentOption = 3;
            return;
        }
        this.currentOption = (this.currentOption - 1) % 4;
    }

    selectOption() {
        return this.options[this.currentOption];
    }

    currentOptionIsNew() {
        return this.selectOption().lastSave === null;
    }

    deleteOption() {
        localStorage.removeItem(`pkmng${this.currentOption}`);
    }
}
